<template>
  <div class="preHeader">
    <div
      class="preHeader__button"
      @click="$_scrollTop"
      @mouseover="updateMouseCursor('button')"
      @mouseout="updateMouseCursor('default')">chiudi</div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ]),
    $_scrollTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss">

@import '../../assets/scss/breakpoint.scss';

$violet: #0b3277;
$white: #f2f2f2;

.preHeader{
  padding: 7.5rem 4% 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: sticky;
  @include media("<large"){
    display: none;
  }
}

.preHeader__button{
  font-size: 1.6rem;
  padding: .5rem;
  color: $violet;
  display: flex;
  align-items: center;
  cursor: pointer;

  .--negative &{
    color: $white;
  }
  &::after{
    content: "";
    display: inline-block;
    width: 3.5rem;
    height: 2px;
    margin-left: 2rem;
    background: $violet;
    transform: scaleX(1);
    transition: transform .3s;
    transform-origin: left;
    .--negative &{
      background: $white;
    }
  }
  &:hover::after{
    transform: scaleX(.75);
  }
}

</style>
